import {
  SnippetElement,
  defineElement,
  globalOn
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/util-announcer/util-announcer.ts
var UtilAnnouncer = class extends SnippetElement {
  connectedCallback() {
    this.announcerElm = this.querySelector("[data-live-region]") || this;
  }
  handleAnnounce(keyOrMessage) {
    const text = this.resolveText(keyOrMessage);
    this.announce(text);
  }
  resolveText(keyOrMessage) {
    switch (keyOrMessage) {
      case "item_added":
        return this.dataset.itemAdded || keyOrMessage;
      case "variant_changed":
        return this.dataset.variantChanged || keyOrMessage;
      case "item_removed":
        return this.dataset.itemRemoved || keyOrMessage;
      case "cart_updated":
        return this.dataset.cartUpdated || keyOrMessage;
      default:
        return keyOrMessage;
    }
  }
  announce(message) {
    if (!this.announcerElm)
      return;
    this.announcerElm.textContent = "";
    setTimeout(() => {
      this.announcerElm.textContent = message;
    }, 50);
  }
};
__decorateClass([
  globalOn("announce")
], UtilAnnouncer.prototype, "handleAnnounce", 1);
UtilAnnouncer = __decorateClass([
  defineElement("util-announcer")
], UtilAnnouncer);
export {
  UtilAnnouncer
};
